import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT } from '@/router/constant'

const { t } = useI18n()

const HomeRoute: AppRouteRecordRaw = {
  path: '/home',
  name: 'Home',
  component: LAYOUT,
  meta: {
    title: t('router.home'),
    icon: 'home',
    hideBreadcrumb: true,
    hideMenu: false,
    perCode: 'home',
    orderNo: 10,
    layout: 'empty',
    master: true
  },
  children: [
    {
      path: '/home',
      name: 'HomeIndex',
      component: () => import('@/views/home/index.vue'),
      meta: {
        title: t('router.home'),
        hideBreadcrumb: true,
        hideMenu: false,
        master: true,
        perCode: 'home',
        layout: 'empty'
      }
    }
  ]
}

export default HomeRoute
